import React, { Fragment, useEffect } from "react";
import gCalendar from "./assets/images/google_calendar.svg"
import cx from "classnames";
import { Button } from "reactstrap";
import requestApiService from "../../services/requestApi.service";
import { useParams } from "react-router-dom";

const CallBack = (props) => {
    const { param } = useParams();
    useEffect(() => {
            (async () => {
                await processCallbackData(param);
            })();
            return () => {
                // this now gets called when the component unmounts
            };
        }, []);

    const processCallbackData = async (param) => {
        let inputData = param;
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "SAVE_OAUTH",
            input : inputData
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let data = response.data;
            if(data === "Google"){
                window.location.href = "#/integrations/google-calendar";
            } else if (data === "GHL"){
                window.location.href = "#/integrations/highlevel";
            }else if (data === "HUB_SPOT"){
                window.location.href = "#/integrations/hubspot";
            }else if(data === "ZOHO"){
                window.location.href = "#/integrations/zoho";
            }else if(data === "BIGIN"){
                window.location.href = "#/integrations/bigin";
            }else if(data === 'salesforce'){
                window.location.href = "#/integrations/salesforce";
            }
        }
    }

    return (
        <Fragment>
            <div>{param}</div>
        </Fragment>
    )
}

export default CallBack;